import * as tslib_1 from "tslib";
import { PopupService } from 'src/app/shared/services/popup/popup.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DaliService } from '@dali/tagger-ng8';
import * as channelConstant from '../../constants/channel.constants';
import { BUSINESS_CONST } from '../../constants/business.constants';
import { OpEnum } from '../../enums/op.enum';
import { BUSINNESS, CHANNEL, COUNTRY, ENVIRONMENT, PAGEVIEW } from '../../constants/dali.constants';
import { CHANNEL as CHANNEL_CONSTANS } from '../../constants/channel.constants';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../capture/capture.service';
import { ChannelCommunicatorService } from '../communicator/channel-communicator/channel-communicator.service';
import { FirmlyApprovedService } from '../firmly-approved/firmly-approved.service';
import { HeaderService } from '../header/header.service';
import { ValidationHelperService } from '../helpers/validation-helper.service';
import { ParametersService } from '../parameters/parameters.service';
import { PostValidateService } from '../post-validate/post-validate.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';
import { TaggingService } from '../tagging/tagging.service';
import { PreValidateService } from '../pre-validate/pre-validate.service';
var NavigationService = /** @class */ (function () {
    /**
     * Summary      Constructor of the component.
     *
     * @param {AbreCuentasService}          abreCuentasService          Injectable abreCuentasService service.
     * @param {PostValidateService}         postValidate                Injectable postValidate angular router.
     * @param {ChannelCommunicatorService}  channelCommunicatorService  Injectable channelCommunicatorService service.
     * @param {RequestService}              requestService              Injectable requestService service.
     * @param {ValidationHelperService}     validationHelperService     injectable validationHelper
     * @param {RequestService}              router                      Injectable router service.
     * @param {DaliService}                 daliService                 Injectable dali service
     * @var   {string[]}                    loadedList                  Set loadedLists as empty array
     * @var   {string[]}                    loadedConfigList            Set loadedConfigList as empty array
     * @var   {boolean}                     loadExitScreen              Set loadExitScreen as empty false
     * @var   {boolean}                     loadCustomScreen            Set loadCustomScreen as empty false
     * @var   {boolean}                     isGeneralInformationStep    Set isGeneralInformationStep as empty false
     */
    function NavigationService(abreCuentasService, postValidate, preValidate, channelCommunicatorService, router, headerService, validationHelperService, taggingService, daliService, _http, productLoaderService, firmlyApprovedService, captureService, parametersService, popupService) {
        this.abreCuentasService = abreCuentasService;
        this.postValidate = postValidate;
        this.preValidate = preValidate;
        this.channelCommunicatorService = channelCommunicatorService;
        this.router = router;
        this.headerService = headerService;
        this.validationHelperService = validationHelperService;
        this.taggingService = taggingService;
        this.daliService = daliService;
        this._http = _http;
        this.productLoaderService = productLoaderService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.captureService = captureService;
        this.parametersService = parametersService;
        this.popupService = popupService;
        this.loadExitScreen = false;
        this.loadCustomScreen = false;
        this.isGeneralInformationStep = false;
        this.storedPreviousStep = [];
    }
    /**
     * Inicializa el flujo obtenido del servicio, este va a ser el flujo que va a seguir la aplicación
     *
     * *Set Up flow obtained from the service, this flow will be followed by the app*
     *
     */
    NavigationService.prototype.startFlow = function (postlogin) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.codeError) return [3 /*break*/, 1];
                        console.error(' <<<<<<<<<<<<<<< Error cargando >>>>>>>>>>>>>>>>>>>>');
                        this.navigateToGeneralInformation(this.codeError);
                        return [3 /*break*/, 5];
                    case 1:
                        console.log('------ startFlow --------');
                        return [4 /*yield*/, this.loadApplicationFlow(postlogin)];
                    case 2:
                        _a.sent();
                        console.log('Flow: ', this.flowStructure);
                        return [4 /*yield*/, this.validateCurrentFlow()];
                    case 3:
                        _a.sent();
                        console.log('CurrentFlow: ', this.currentFlow);
                        return [4 /*yield*/, this.validateCurrentPhase()];
                    case 4:
                        _a.sent();
                        this.navigateTo(this.currentPhase.start);
                        console.log('------ Fin startFlow --------');
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Función encargada de validar si viene por CE o CN,
     * para así asignar el flow correspondiente; dado que si
     * viene de CE, el usuario selecciona un producto desde el HOME
     */
    NavigationService.prototype.validateCurrentFlow = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var productSelected;
            return tslib_1.__generator(this, function (_a) {
                if (this.abreCuentasService.getPostlogin() && !this.popupService.continueWithFirmlyApproved) {
                    productSelected = this.abreCuentasService.getproductSelected() ? this.abreCuentasService.getproductSelected().flow : this.flowStructure[0].startFlow;
                }
                else {
                    productSelected = this.flowStructure[0].startFlow;
                }
                console.warn('<<<<<<< Product selected: ', productSelected);
                this.currentFlow = this.flowStructure[0].flows[productSelected];
                return [2 /*return*/];
            });
        });
    };
    /**
     * Función encargada de ajustar la Fase a Iniciar en onboarding.
     */
    NavigationService.prototype.validateCurrentPhase = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.currentPhase = this.currentFlow.phases[this.currentFlow.startPhase];
                console.log('currentPhase: ', this.currentPhase);
                this.currentPhase.key = this.currentFlow.startPhase;
                this.currentStep = this.currentPhase.steps[this.currentPhase.start];
                console.log(this.currentStep, 'current');
                this.currentStep.key = this.currentPhase.start;
                return [2 /*return*/];
            });
        });
    };
    NavigationService.prototype.sentDataToPCO = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.captureService.performPco().then(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            return tslib_1.__generator(this, function (_a) {
                                return [2 /*return*/];
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /* istanbul ignore next */
    /**
     * Cambia de pantalla de acuerdo al flujo inicial
     *
     * *change screen according to initial flow*
     *
     */
    NavigationService.prototype.nextStep = function (code) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var validate, validateCode_1, validate_1, validate_1_1, func, error_1, e_1_1, validate, validateCode_2, validate_2, validate_2_1, func, error_2, e_2_1, next_p, next;
            var e_1, _a, e_2, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        console.log('------ nextStep --------');
                        console.log(code);
                        console.log('currentStep: ', this.currentStep);
                        if (this.currentStep && this.currentStep['sendpco']) {
                            this.sentDataToPCO();
                        }
                        if (this.currentStep.savePrevious) {
                            if (this.currentStep.next[code || 'default'].indexOf('$phase') >= 0) {
                                this.storedPreviousStep[this.currentStep.next[code || 'default']] = "$phase/" + this.currentPhase.key + "/" + this.currentStep.key;
                            }
                            else {
                                this.storedPreviousStep["$phase/" + this.currentPhase.key + "/" + this.currentStep.next[code || 'default']] = "$phase/" + this.currentPhase.key + "/" + this.currentStep.key;
                            }
                        }
                        if (!this.currentStep.preValidate) return [3 /*break*/, 11];
                        validate = this.currentStep.preValidate[code || 'default'];
                        validateCode_1 = '200';
                        if (!validate) return [3 /*break*/, 11];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 9, 10, 11]);
                        validate_1 = tslib_1.__values(validate), validate_1_1 = validate_1.next();
                        _c.label = 2;
                    case 2:
                        if (!!validate_1_1.done) return [3 /*break*/, 8];
                        func = validate_1_1.value;
                        _c.label = 3;
                    case 3:
                        _c.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.preValidate
                                .switchFunction(func)
                                .then(function (res) {
                                validateCode_1 = res;
                            })];
                    case 4:
                        _c.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_1 = _c.sent();
                        console.log(error_1);
                        return [3 /*break*/, 6];
                    case 6:
                        if (func == 'getPcoAmount') {
                            code = validateCode_1;
                        }
                        if (validateCode_1 !== '200' && validateCode_1 !== '201' && validateCode_1 !== '202') {
                            this.navigateToGeneralInformation(validateCode_1);
                            return [2 /*return*/];
                        }
                        _c.label = 7;
                    case 7:
                        validate_1_1 = validate_1.next();
                        return [3 /*break*/, 2];
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        e_1_1 = _c.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 11];
                    case 10:
                        try {
                            if (validate_1_1 && !validate_1_1.done && (_a = validate_1.return)) _a.call(validate_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 11:
                        if (!this.currentStep.postValidate) return [3 /*break*/, 23];
                        validate = this.currentStep.postValidate[code || 'default'];
                        console.log('Requiere el siguiente PostValidate >>>> ', validate);
                        validateCode_2 = '200';
                        if (!validate) return [3 /*break*/, 22];
                        _c.label = 12;
                    case 12:
                        _c.trys.push([12, 20, 21, 22]);
                        validate_2 = tslib_1.__values(validate), validate_2_1 = validate_2.next();
                        _c.label = 13;
                    case 13:
                        if (!!validate_2_1.done) return [3 /*break*/, 19];
                        func = validate_2_1.value;
                        _c.label = 14;
                    case 14:
                        _c.trys.push([14, 16, , 17]);
                        return [4 /*yield*/, this.postValidate
                                .switchFunction(func)
                                .then(function (res) { return (validateCode_2 = res || validateCode_2); })];
                    case 15:
                        _c.sent();
                        return [3 /*break*/, 17];
                    case 16:
                        error_2 = _c.sent();
                        console.log(error_2);
                        return [3 /*break*/, 17];
                    case 17:
                        if (validateCode_2 === 'secondCall') {
                            // this.pageLoadTag(false, ['pv235', '', '', '', '']);
                            this.navigateToGeneralInformation('125');
                            return [2 /*return*/];
                        }
                        if (validateCode_2 !== '200' && validateCode_2 !== '201') {
                            this.navigateToGeneralInformation(validateCode_2);
                            return [2 /*return*/];
                        }
                        _c.label = 18;
                    case 18:
                        validate_2_1 = validate_2.next();
                        return [3 /*break*/, 13];
                    case 19: return [3 /*break*/, 22];
                    case 20:
                        e_2_1 = _c.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 22];
                    case 21:
                        try {
                            if (validate_2_1 && !validate_2_1.done && (_b = validate_2.return)) _b.call(validate_2);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 22:
                        next_p = !code
                            ? this.currentStep.next['default']
                            : this.currentStep.next[code];
                        this.goToStep(next_p);
                        this.productLoaderService.hide();
                        return [2 /*return*/];
                    case 23:
                        if (code && code !== '200' && code !== '207' && code !== '205' && code !== '202') {
                            this.abreCuentasService.caseInfoError(code);
                        }
                        next = !code
                            ? this.currentStep.next['default']
                            : this.currentStep.next[code];
                        console.log('next p', next);
                        console.log('------ Fin nextStep --------');
                        this.goToStep(next);
                        this.productLoaderService.hide();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Cambia a la pantalla anterior del flujo
     *
     * *Move back to the previous screen of the flow*
     *
     */
    NavigationService.prototype.previousStep = function () {
        var previous = '';
        var currentStep = this.getCurrentStep();
        if (currentStep.previous === 'form-employee') {
            switch (this.abreCuentasService.getOccupationSelected().id) {
                case 1:
                    previous = 'form-employee';
                    break;
                case 2:
                    previous = 'form-employee-independent';
                    break;
                case 3:
                case 4:
                case 5:
                    previous = 'occupation-tc';
                    break;
            }
        }
        else {
            previous = currentStep.previous;
            if (previous === 'previousControled') {
                var phase = "$phase/" + this.currentPhase.key + "/" + currentStep.key;
                previous = this.storedPreviousStep[phase];
            }
        }
        this.goToStep(previous);
    };
    NavigationService.prototype.previousStepMulti = function (code) {
        var currentStep = this.getCurrentStep();
        this.goToStep(currentStep.previous[code]);
    };
    /* istanbul ignore next */
    /**
     * Cambia a una pantalla especifica del flujo
     *
     * *Move to a specific screen from the flow*
     */
    NavigationService.prototype.goToStep = function (step) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newStep;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('------- goToStep ------');
                        console.log('step: ', step);
                        if (!step) return [3 /*break*/, 5];
                        if (!(step === '$exit')) return [3 /*break*/, 1];
                        this.loadExitScreen = true;
                        return [3 /*break*/, 5];
                    case 1:
                        if (!(step === '$login-app')) return [3 /*break*/, 2];
                        this.goToLoginPage();
                        return [3 /*break*/, 5];
                    case 2:
                        if (!(step === '$firmlyApproved')) return [3 /*break*/, 4];
                        console.log('---------redirect to firmlyApproved---------');
                        return [4 /*yield*/, this.startFlow(this.abreCuentasService.getPostlogin())];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        if (step.startsWith('$flow')) {
                            if (step.split('/').length === 2) {
                                this.goToFlowSteps(step.split('/')[1]);
                            }
                            else if (step.split('/').length === 3) {
                                this.goToFlowSteps(step.split('/')[1], step.split('/')[2]);
                            }
                            else if (step.split('/').length === 4) {
                                this.goToFlowSteps(step.split('/')[1], step.split('/')[2], step.split('/')[3]);
                            }
                        }
                        else if (step.startsWith('$phase/')) {
                            if (step.split('/').length > 2) {
                                this.changeToPhase(step.split('/')[1], step.split('/')[2]);
                            }
                            else {
                                this.changeToPhase(step.split('/')[1]);
                            }
                        }
                        else if (step === '$customBack') {
                            this.loadCustomScreen = true;
                        }
                        else {
                            newStep = this.currentPhase.steps[step];
                            if (newStep) {
                                this.currentStep = newStep;
                                this.currentStep.key = step;
                                this.isGeneralInformationStep = false;
                                this.navigateTo(step);
                            }
                        }
                        _a.label = 5;
                    case 5:
                        setTimeout(function () {
                            _this.pageLoadTag();
                        }, 500);
                        console.log('------- Fin goToStep ------');
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Cambia a la pantalla de ingreso
     *
     * *Move back to login screen*
     *
     */
    NavigationService.prototype.goToLoginPage = function () {
        this.channelCommunicatorService
            .getImpl()
            .redirectToLoginView()
            .then(function (_response) {
            return;
        });
    };
    /* istanbul ignore next */
    /**
     * Navega al paso seleccionado de acuerdo al flujo
     *
     * *Navigate to selected step from flow*
     *
     * @param {string} flow
     * @param {string} phase
     * @param {string} step
     */
    // tslint:disable-next-line: no-shadowed-variable
    NavigationService.prototype.goToFlowSteps = function (flow, phase, step) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var selectedPhase, selectedStep;
            return tslib_1.__generator(this, function (_a) {
                console.log('----------- goToFlowSteps ---------------');
                console.log('Flujo recibido: ', flow);
                console.log('Flujo onboarding: ', this.flowStructure);
                this.currentFlow = this.flowStructure[0].flows[flow];
                console.log('CurrentFlow: ', this.currentFlow);
                selectedPhase = this.flowStructure[0].flows[flow].startPhase;
                this.abreCuentasService.setPhase(selectedPhase);
                selectedStep = this.flowStructure[0].flows[flow].phases[this.flowStructure[0].flows[flow].startPhase].start;
                if (phase && !step) {
                    selectedPhase = phase;
                }
                else if (phase && step) {
                    selectedPhase = phase;
                    selectedStep = step;
                }
                this.currentPhase = this.flowStructure[0].flows[flow].phases[selectedPhase];
                this.currentPhase.key = phase ? phase : selectedPhase;
                this.currentStep = this.currentPhase.steps[selectedStep];
                this.currentStep.key = selectedStep;
                this.isGeneralInformationStep = false;
                console.log('----------- Fin goToFlowSteps ---------------');
                this.navigateTo(selectedStep);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Cambia a la pantalla de agencias
     *
     * *Move to AgenciesPage*
     *
     */
    NavigationService.prototype.goToAgenciesPage = function () {
        this.channelCommunicatorService
            .getImpl()
            .redirectToAgencyListView()
            .then(function (_response) {
            return;
        });
    };
    /**
     * Cambia a la pantalla de información general
     *
     * *Move to general infromation screen*
     *
     * @param {string} code
     */
    NavigationService.prototype.navigateToGeneralInformation = function (code) {
        this.actualStep = code;
        this.productLoaderService.hide();
        this.isGeneralInformationStep = true;
        this.abreCuentasService.caseInfoError(code);
        this.navigateTo('general-information');
        this.sendTagByCode(code, this.abreCuentasService.errorInfo);
    };
    /**
     * Se devuelve al paso actual
     *
     * *Return to currente step*
     *
     */
    NavigationService.prototype.returnToCurrentStep = function () {
        this.isGeneralInformationStep = false;
        this.navigateTo(this.currentStep.key);
    };
    /* istanbul ignore next */
    /**
     * Navega a la fase seleccionada del flujo
     *
     * *Navigate to selected phase from flow*
     *
     */
    NavigationService.prototype.changeToPhase = function (phase, step) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nextPhase;
            return tslib_1.__generator(this, function (_a) {
                this.abreCuentasService.setPhase(phase);
                nextPhase = this.flowStructure[0].flows[this.currentFlow.name].phases[phase];
                if (!nextPhase) {
                    return [2 /*return*/];
                }
                this.currentPhase = nextPhase;
                this.currentPhase.key = phase;
                if (step) {
                    this.currentStep = this.currentPhase.steps[step];
                    this.currentStep.key = step;
                    this.navigateTo(step);
                }
                else {
                    this.currentStep = this.currentPhase.steps[nextPhase.start];
                    this.currentStep.key = nextPhase.start;
                    this.navigateTo(this.currentPhase.start);
                }
                return [2 /*return*/];
            });
        });
    };
    /**
     * Cambia a la pantalla especifica del flujo
     *
     * *Move to a specific screen of the flow*
     *
     */
    NavigationService.prototype.navigateTo = function (route) {
        console.log('navigate', route);
        this.headerService.hide();
        console.log(this.router);
        this.router.navigate([route], { skipLocationChange: true });
        window.scrollTo(0, 0);
    };
    /**
     * Aplica el Formato CamelCase al
     *
     * *Format text to CamelCase*
     *
     * @param {string} text
     *
     */
    NavigationService.prototype.camelize = function (text) {
        var str = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        return str
            .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, _index) {
            return word.toUpperCase();
        })
            .replace(/\s+/g, '');
    };
    /**
     * Obtiene el paso actual
     *
     * *Get current step*
     *
     * @returns {StepType} this.currentStep
     */
    NavigationService.prototype.getCurrentStep = function () {
        return this.currentStep;
    };
    NavigationService.prototype.setCurrentStep = function (value) {
        this.currentStep = value;
    };
    /**
     * Obtiene la phase actual
     *
     * *Get current phase*
     *
     * @returns {PhaseType} this.currentPhase
     */
    NavigationService.prototype.getCurrentPhase = function () {
        return this.currentPhase;
    };
    /**
     * Obtiene el flujo actual
     *
     * *Get current flujo*
     *
     * @returns {IFlowType} this.currentFlow
     */
    NavigationService.prototype.getCurrentProductProcess = function () {
        return this.currentFlow;
    };
    /**
     * Configura los tags de la página para hacer un page view a Google Analytics
     *
     * *Load page tag to make a page view to send to Google Analytics*
     *
     * @param {any} errorName
     * @param {string[]} tagsPageName
     * @param {string []} userPPID
     */
    NavigationService.prototype.pageLoadTag = function (errorName, tagsPageName, tagId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var channelId, aplicationId, developmenttype, currentStepEs, stepName, tagPageId, tagPageName, loggeado, daliEnv, changes, 
            /*selectedPayDay,*/
            selectedProduct, selectedPayDay, cardCategory, occupation;
            return tslib_1.__generator(this, function (_a) {
                channelId = this.channelCommunicatorService.getChannelId();
                aplicationId = channelId === '141' ? CHANNEL.superapp : CHANNEL.homeBanking;
                developmenttype = channelId === CHANNEL_CONSTANS.SUPERAPP.CODE ? 'App' : 'Web';
                if (tagsPageName && tagsPageName.length === 4) {
                    this.taggingService.setTagId(tagsPageName[0], tagsPageName[1], tagsPageName[2], tagsPageName[3]);
                }
                currentStepEs = this.getCurrentStep().es;
                stepName = currentStepEs ? currentStepEs : 'Pantalla de error';
                tagPageId = stepName === '$type-product-selected'
                    ? this.camelize(this.abreCuentasService.getproductSelected().es)
                    : this.camelize(stepName);
                tagPageName = tagsPageName ? this.taggingService.getTagIdByProduct() : (tagId ? tagId : this.getCurrentStep().tag_name);
                console.log('------ pageLoadTag--------');
                console.log(tagPageName);
                console.log(tagsPageName);
                console.log(this.getCurrentStep().tag_name);
                loggeado = this.abreCuentasService.getPostlogin() ? ENVIRONMENT.loggeado : ENVIRONMENT.noLoggeado;
                daliEnv = this.parametersService.getParameter('daliEnvProd');
                try {
                    changes = [
                        {
                            path: PAGEVIEW.environment.path,
                            value: daliEnv ? 'Prod' : 'Dev',
                        },
                        {
                            path: PAGEVIEW.clientIdpf.path,
                            value: this.abreCuentasService.getPostlogin() ? this.abreCuentasService.getPPID() : '',
                        },
                        // {
                        //   path: PAGEVIEW.developmenttype.path,
                        //   value: developmenttype,
                        // },
                        {
                            path: PAGEVIEW.developmenttype.path,
                            value: aplicationId === 'SA' ? 'App' : 'Web',
                        },
                        {
                            path: PAGEVIEW['channel_' + this.channelCommunicatorService.getChannelId()].path,
                            value: aplicationId === 'SA'
                                ? PAGEVIEW.channel_141.value
                                : PAGEVIEW.channel_131.value,
                        },
                        {
                            path: PAGEVIEW.useragent.path,
                            value: navigator.userAgent,
                        },
                        {
                            path: PAGEVIEW.permissions.path,
                            value: this.abreCuentasService.getDevicePermissions() === '' ?
                                'NotAvailable' : this.abreCuentasService.getDevicePermissions(),
                        },
                        {
                            path: PAGEVIEW.geolocation.path,
                            value: 'NotAvailable',
                        },
                        {
                            path: PAGEVIEW[tagPageName + "pageName"].path,
                            value: aplicationId + ':' + COUNTRY.co + ':' + BUSINNESS.pf + ':' + loggeado
                                + ':' + PAGEVIEW[tagPageName + "pageFamily"].value + ':' + PAGEVIEW[tagPageName + "subFamily"].value + ':'
                                + PAGEVIEW[tagPageName + "pageAction"].value + ':' + PAGEVIEW[tagPageName + "pageName"].value,
                        },
                        {
                            path: PAGEVIEW[tagPageName + "pageFamily"].path,
                            value: PAGEVIEW[tagPageName + "pageFamily"].value,
                        },
                        {
                            path: PAGEVIEW[tagPageName + "subFamily"].path,
                            value: PAGEVIEW[tagPageName + "subFamily"].value,
                        },
                        {
                            path: PAGEVIEW[tagPageName + "pageAction"].path,
                            value: PAGEVIEW[tagPageName + "pageAction"].value,
                        },
                        {
                            path: PAGEVIEW[tagPageName + "pageid"].path,
                            value: tagPageId,
                        },
                    ];
                    if (PAGEVIEW[tagPageName + "transactionName"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "transactionName"].path,
                            value: PAGEVIEW[tagPageName + "transactionName"].value,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "customTransactionSimulationValue"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "customTransactionSimulationValue"].path,
                            value: this.abreCuentasService.getPcoModel().granted_product.limit_amount.amount.toString(),
                        });
                    }
                    if (PAGEVIEW[tagPageName + "customTransactionCompletedValue"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "customTransactionCompletedValue"].path,
                            value: this.abreCuentasService.getPcoModel().granted_product.limit_amount.amount.toString(),
                        });
                    }
                    if (PAGEVIEW[tagPageName + "transactionProductCategory"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "transactionProductCategory"].path,
                            value: PAGEVIEW[tagPageName + "transactionProductCategory"].value,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "customTransactionStep"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "customTransactionStep"].path,
                            value: PAGEVIEW[tagPageName + "customTransactionStep"].value,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "transactionTransactionStep"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "transactionTransactionStep"].path,
                            value: PAGEVIEW[tagPageName + "transactionTransactionStep"].value,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "customTransactionCheckout"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "customTransactionCheckout"].path,
                            value: PAGEVIEW[tagPageName + "customTransactionCheckout"].value,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "customTransactionComplete"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "customTransactionComplete"].path,
                            value: PAGEVIEW[tagPageName + "customTransactionComplete"].value,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "cardlimitrange"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "cardlimitrange"].path,
                            value: this.abreCuentasService.getAmountPcoAproved(),
                        });
                    }
                    if (PAGEVIEW[tagPageName + "status"]) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "status"].path,
                            value: this.abreCuentasService.getTransactionStatus() ? this.abreCuentasService.getTransactionStatus() : 'Aprobado',
                        });
                    }
                    /*if (PAGEVIEW[`${tagPageName}cardpartner`]) {
                      changes.push({
                        path: PAGEVIEW[`${tagPageName}cardpartner`].path,
                        value: 'traer de un servicio', // crear variable en servicio, que va a traer esta info
                      })
                    }*/
                    if (PAGEVIEW[tagPageName + "cardnetwork"]) {
                        selectedProduct = this.abreCuentasService.getPayDayProductSelected().selectedProduct;
                        changes.push({
                            path: PAGEVIEW[tagPageName + "cardnetwork"].path,
                            value: selectedProduct.label,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "installmentsterm"]) {
                        selectedPayDay = this.abreCuentasService.getPayDayProductSelected().selectedPayDay;
                        changes.push({
                            path: PAGEVIEW[tagPageName + "installmentsterm"].path,
                            value: selectedPayDay.label,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "cardcategory"]) {
                        cardCategory = this.abreCuentasService.getCardTypeModel().tipo_tarjeta;
                        changes.push({
                            path: PAGEVIEW[tagPageName + "cardcategory"].path,
                            value: cardCategory,
                        });
                    }
                    if (PAGEVIEW[tagPageName + "transactionProductDetails"]) {
                        occupation = this.abreCuentasService.getOccupationSelected().name;
                        changes.push({
                            path: PAGEVIEW[tagPageName + "transactionProductDetails"].path,
                            value: occupation,
                        });
                    }
                    if (errorName) {
                        changes.push({
                            path: PAGEVIEW[tagPageName + "errorname"].path,
                            value: this.camelize(errorName),
                        });
                    }
                    this.daliService.pageLoad(changes);
                }
                catch (error) {
                    console.log("error en el dali..  " + error);
                }
                console.log('------ fin pageLoadTag--------');
                return [2 /*return*/];
            });
        });
    };
    NavigationService.prototype.loadApplicationFlow = function (postlogin, url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var constant, urlConstant;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('------ Load Application Flow --------');
                        try {
                            constant = Object.values(channelConstant.CHANNEL);
                            urlConstant = constant.find(function (element) {
                                return element.CODE === _this.channelCommunicatorService.getChannelId();
                            });
                            url = postlogin ? urlConstant.POST : urlConstant.PRE;
                        }
                        catch (error) {
                            console.error({ error: 'no encontro canal', datalle: error });
                        }
                        return [4 /*yield*/, this.setFlowStructure(url)];
                    case 1:
                        _a.sent();
                        console.log('------ Fin Load Application Flow --------');
                        return [2 /*return*/];
                }
            });
        });
    };
    NavigationService.prototype.setFlowStructure = function (url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._http.get(url).toPromise().then(function (response) {
                            console.log('Channel_AF --- FirmlyApprovedService ---> ', _this.firmlyApprovedService);
                            var route;
                            if (!_this.firmlyApprovedService.isEmpty() && _this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
                                route = 'aprobados_en_firme_multi';
                            }
                            else if (!_this.firmlyApprovedService.isEmpty()) {
                                route = '';
                            }
                            else {
                                route = 'abrecuentas_flow_co';
                            }
                            console.log('Ruta a tomar ---->>> ', route);
                            _this.flowStructure = _this.routeApplicationFlow(route, response['data']);
                            console.log('Flujo a seguir >>>> \n', _this.flowStructure);
                            _this.abreCuentasService.setFlowStructure(_this.flowStructure);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // feature-living-integration
    // async pageLoadTag(errorName?: any, tagsPageName?: string[]) {
    //   const channelId = this.channelCommunicatorService.getChannelId();
    //   const aplicationId = channelId === '141' ? CHANNEL.superapp : CHANNEL.homeBanking;
    //   if (tagsPageName && tagsPageName.length === 4) {
    //     this.taggingService.setTagId(
    //       tagsPageName[0],
    //       tagsPageName[1],
    //       tagsPageName[2],
    //       tagsPageName[3],
    //     );
    //   }
    NavigationService.prototype.loadMultiproductFlowUpdate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var url;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = './assets/resources/multiproduct_flow_update.json';
                        return [4 /*yield*/, this._http
                                .get(url)
                                .toPromise()
                                .then(function (dataResponse) {
                                _this.multiproductFlowUpdate = dataResponse;
                                _this.abreCuentasService.setMultiproductFlowUpdate(_this.multiproductFlowUpdate);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NavigationService.prototype.isCardDuality = function () {
        var limits = this.parametersService.getSetting(OpEnum.MULTIPLE_PRODUCT_TC_LIMITS);
        var pcoModel = this.abreCuentasService.getPcoModel();
        var isGrayZone = this.firmlyApprovedService.isEmpty() ? pcoModel.solicitation_status.status_code === 'PCO03' ? true : false : false;
        var ProductsList;
        var self = this.abreCuentasService.getAbreCuentasModel();
        var productType = this.abreCuentasService.getproductSelected().product_type;
        var itemsSelected = this.abreCuentasService.getProductsSelects();
        var aprovedAmount = 0;
        switch (productType) {
            case BUSINESS_CONST.MULTI:
                ProductsList = self.pcoModel.granted_product_multi;
                break;
            default:
                ProductsList = [self.pcoModel.granted_product];
                break;
        }
        ProductsList.forEach(function (product, index) {
            if (itemsSelected.length > 0 && itemsSelected[index].product_type === product.product_type) {
                aprovedAmount = product.limit_amount.amount;
            }
            // aprovedAmount = pcoModel.granted_product.limit_amount.amount;
        });
        // const aprovedAmount = pcoModel.granted_product.limit_amount.amount;
        var multipleProduct = aprovedAmount >= limits.minimumAmount ? true : false;
        var isSelectedSeveralfranchises = Array.isArray(this.abreCuentasService.getPayDayProductSelected().selectedProduct);
        this.cardDuality = !isGrayZone && multipleProduct && isSelectedSeveralfranchises;
        this.abreCuentasService.setCarduality(this.cardDuality);
        console.warn('Gray zone ', !isGrayZone);
        console.warn('multiple product ', multipleProduct);
        console.warn('IsSelectedSeveralFranquises ', isSelectedSeveralfranchises);
        console.warn('IS CARD DUALITY ', !isGrayZone && multipleProduct && isSelectedSeveralfranchises);
        return !isGrayZone && multipleProduct && isSelectedSeveralfranchises;
    };
    /**
     * metodos para validar siguiente en flujo multiproducto
     * @param flows flujos seleccionados
     */
    NavigationService.prototype.nextMulti = function (flows) {
        var codeNext = '200';
        if (!this.firmlyApprovedService.isEmpty() && this.firmlyApprovedService.getOfferType_Channel() === 'En_firme') {
            codeNext = this.nextFirmlyApprovedMulti(flows);
        }
        else if (this.abreCuentasService.getPostlogin() === true) {
            switch (this.getCurrentStep().key) {
                case 'disbursement-offices-search':
                    codeNext = this.flowloan(this.getCurrentStep(), flows);
                    break;
                case 'configuration-introduction':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        if (!this.abreCuentasService.getClientProduct()) {
                            this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
                        }
                        codeNext = '200';
                    }
                    else if (flows.length == 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })
                        && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'configuration-introduction';
                        codeNext = '201';
                    }
                    else if (this.abreCuentasService.getWasDeleteLoan()) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else {
                        if (!this.abreCuentasService.getClientProduct()) {
                            this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
                        }
                        codeNext = '200';
                    }
                    break;
                case 'account-selection':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.length == 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; }) &&
                        flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        codeNext = '202';
                    }
                    else if (flows.length == 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; }) &&
                        flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        codeNext = '206';
                    }
                    else if (flows.length == 3 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })
                        && this.abreCuentasService.getAssociateCopyRevolving()) {
                        codeNext = '200';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                        this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'account-selection';
                        codeNext = '201';
                    }
                    else {
                        codeNext = '200';
                    }
                    break;
                case 'pay-day-form-tc':
                    if (this.isCardDuality()) {
                        // this.getCurrentPhase().steps['address-config-tc'].previous = 'virtual-card-franchise';
                        codeNext = '202';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.length === 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        codeNext = '201';
                    }
                    else {
                        if (this.abreCuentasService.getClientProduct()) {
                            this.getCurrentPhase().steps['address-config-tc'].previous = 'pay-day-form-tc';
                            codeNext = '201';
                        }
                        else {
                            this.getCurrentPhase().steps['receive-card'].previous = 'pay-day-form-tc';
                            codeNext = '200';
                        }
                    }
                    break;
                case 'virtual-card-franchise':
                    if (flows.length === 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        if (this.abreCuentasService.getClientProduct()) {
                            this.getCurrentPhase().steps['account-selection-rotativo'].previous = 'virtual-card-franchise';
                            codeNext = '206';
                        }
                        else {
                            this.getCurrentPhase().steps['opening-savings-account'].previous = 'virtual-card-franchise';
                            codeNext = '202';
                        }
                    }
                    else {
                        if (this.abreCuentasService.getClientProduct()) {
                            this.getCurrentPhase().steps['address-config-tc'].previous = 'virtual-card-franchise';
                            codeNext = '200';
                        }
                        else {
                            this.getCurrentPhase().steps['receive-card'].previous = 'virtual-card-franchise';
                            codeNext = '203';
                        }
                    }
                    break;
                case 'address-config-tc':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                            if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                                if (this.abreCuentasService.getcreateProductSelected()) {
                                    codeNext = '206';
                                }
                                else {
                                    codeNext = '200';
                                }
                            }
                            else {
                                // } else if (flows.length === 2 && flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING)) {
                                //   if(flows.find(find => find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC)){
                                codeNext = '200';
                            }
                            // this.getCurrentPhase().steps['account-selection'].previous = 'address-config-tc';
                        }
                        else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                            codeNext = '203';
                        }
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.length === 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        if (this.abreCuentasService.getClientProduct()) {
                            // this.getCurrentPhase().steps['account-selection-rotativo'].previous = 'address-config-tc';
                            codeNext = '206';
                        }
                        else {
                            // this.getCurrentPhase().steps['opening-savings-account'].previous = 'address-config-tc';
                            codeNext = '204';
                        }
                    }
                    else {
                        codeNext = '200';
                    }
                    break;
                case 'confirm-phone':
                    if (flows.find(function (find) { return find.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        if (flows.find(function (find) { return find.flow === BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                            this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'confirm-phone';
                            codeNext = '202';
                        }
                    }
                    else {
                        this.getCurrentPhase().steps['advisor-code'].previous = 'confirm-phone';
                        codeNext = '201';
                    }
                    break;
                case 'opening-savings-account':
                    if (flows.find(function (find) { return find.flow === BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if ((flows.length === 2)) {
                        if (flows.find(function (find) { return find.flow === BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                            if (flows.find(function (find) { return find.flow === BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                                this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
                                codeNext = '201';
                            }
                            else {
                                this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'opening-savings-account';
                                this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
                                codeNext = '200';
                            }
                        }
                        else if (flows.find(function (find) { return find.flow != BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                            this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
                            codeNext = '201';
                        }
                    }
                    else {
                        this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'opening-savings-account';
                        this.getCurrentPhase().steps['opening-savings-account'].previous = 'outlay-selection';
                        codeNext = '200';
                    }
                    break;
                case 'receive-card':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (this.abreCuentasService.getOfficeStatus()) {
                        this.getCurrentPhase().steps['advisor-code'].previous = 'receive-card';
                        codeNext = '200';
                    }
                    else {
                        this.getCurrentPhase().steps['address-config-tc'].previous = 'receive-card';
                        codeNext = '201';
                    }
                    break;
                case 'city-offices-search':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    break;
                case 'outlay-other-bank':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    break;
            }
        }
        else {
            switch (this.getCurrentStep().key) {
                case 'disbursement-offices-search':
                    codeNext = this.flowloan(this.getCurrentStep(), flows);
                    break;
                case 'configuration-introduction':
                    codeNext = '200';
                    this.getCurrentPhase().steps['city-offices-search'].previous = 'configuration-introduction';
                    break;
                case 'city-offices-search':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        codeNext = '200';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                        this.getCurrentPhase().steps['pay-day-form-tc'].previous = 'city-offices-search';
                        codeNext = '201';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        codeNext = '200';
                    }
                    break;
                case 'opening-savings-account':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        if (flows.length === 3) {
                            codeNext = '200';
                        }
                        else if (flows.length === 2 && flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                            codeNext = '200';
                        }
                        else {
                            this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
                            codeNext = '201';
                        }
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        this.getCurrentPhase().steps['receive-card'].previous = 'opening-savings-account';
                        codeNext = '201';
                    }
                    break;
                case 'pay-day-form-tc':
                    if (this.isCardDuality()) {
                        codeNext = '202';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        this.getCurrentPhase().steps['receive-card'].previous = 'pay-day-form-tc';
                        codeNext = '204';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        this.getCurrentPhase().steps['opening-savings-account'].previous = 'pay-day-form-tc';
                        codeNext = '200';
                    }
                    break;
                case 'address-config-tc':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; }) || flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        codeNext = '200';
                    }
                    else {
                        codeNext = '201';
                    }
                    break;
                case 'virtual-card-franchise':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_FREE; })) {
                        this.getCurrentPhase().steps['receive-card'].previous = 'virtual-card-franchise';
                        this.getCurrentPhase().steps['address-config-tc'].previous = 'receive-card';
                        codeNext = '201';
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        this.getCurrentPhase().steps['opening-savings-account'].previous = 'virtual-card-franchise';
                        codeNext = '202';
                    }
                    else {
                        this.getCurrentPhase().steps['address-config-tc'].previous = 'virtual-card-franchise';
                        codeNext = '200';
                    }
                    break;
                case 'confirm-phone':
                    // this.getCurrentPhase().steps['advisor-code'].previous = 'confirm-phone';
                    codeNext = '201';
                    break;
                case 'receive-card':
                    if (this.abreCuentasService.getOfficeStatus()) {
                        this.getCurrentPhase().steps['confirm-phone'].previous = 'receive-card';
                        codeNext = '200';
                    }
                    else {
                        this.getCurrentPhase().steps['address-config-tc'].previous = 'receive-card';
                        codeNext = '201';
                    }
                    break;
                case 'outlay-other-bank':
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_LOAN; })) {
                        codeNext = this.flowloan(this.getCurrentStep(), flows);
                    }
                    break;
                default:
                    break;
            }
        }
        return codeNext;
    };
    NavigationService.prototype.nextFirmlyApprovedMulti = function (productsSelect) {
        var _this = this;
        var productsType = {
            ORD: productsSelect.find(function (product) { return product.product === BUSINESS_CONST.PRODUCT_CODE_FREE; }),
            TCR: productsSelect.find(function (product) { return product.product === BUSINESS_CONST.PRODUCT_CODE_TCR; }),
            CRP: productsSelect.find(function (product) { return product.product === BUSINESS_CONST.PRODUCT_CODE_CRP; }),
        };
        var codeNext = {
            'default': function () { return channelConstant.CODE_NAVIGATION.CODE_200; },
            'configuration-introduction': function () {
                if (productsSelect.length === 2
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
                    return channelConstant.CODE_NAVIGATION.CODE_201;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
            },
            'account-selection': function () {
                if (productsSelect.length === 2 &&
                    productsType[BUSINESS_CONST.PRODUCT_CODE_TCR] &&
                    productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
                    return channelConstant.CODE_NAVIGATION.CODE_202;
                }
                else if (productsSelect.length === 2 &&
                    productsType[BUSINESS_CONST.PRODUCT_CODE_FREE] &&
                    productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
                    return channelConstant.CODE_NAVIGATION.CODE_206;
                }
                else if (productsSelect.length === 3 &&
                    productsType[BUSINESS_CONST.PRODUCT_CODE_CRP] &&
                    _this.abreCuentasService.getAssociateCopyRevolving()) {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
                else if (productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]) {
                    return channelConstant.CODE_NAVIGATION.CODE_201;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
            },
            'pay-day-form-tc': function () {
                if (_this.isCardDuality()) {
                    return channelConstant.CODE_NAVIGATION.CODE_202;
                }
                else if ((productsSelect.length === 2 && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP])
                    || _this.abreCuentasService.getClientProduct()) {
                    return channelConstant.CODE_NAVIGATION.CODE_201;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
            },
            'virtual-card-franchise': function () {
                if (productsSelect.length === 2 && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP] && !_this.abreCuentasService.getClientProduct()) {
                    return channelConstant.CODE_NAVIGATION.CODE_202;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
            },
            'address-config-tc': function () {
                if (productsSelect.length === 3 && _this.abreCuentasService.getcreateProductSelected()
                    || (productsSelect.length === 2
                        && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]
                        && productsType[BUSINESS_CONST.PRODUCT_CODE_FREE]
                        && _this.abreCuentasService.getClientProduct())) {
                    return channelConstant.CODE_NAVIGATION.CODE_203;
                }
                else if (productsSelect.length === 2
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]
                    && !_this.abreCuentasService.getClientProduct()) {
                    return channelConstant.CODE_NAVIGATION.CODE_204;
                }
                else if (productsSelect.length === 2
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]) {
                    return channelConstant.CODE_NAVIGATION.CODE_206;
                }
                else if (productsSelect.length === 2
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP]) {
                    return channelConstant.CODE_NAVIGATION.CODE_204;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
            },
            'confirm-phone': function () {
                if (productsSelect.length === 2
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_FREE]
                    && productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]) {
                    return channelConstant.CODE_NAVIGATION.CODE_202;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_201;
                }
            },
            'opening-savings-account': function () {
                if (productsSelect.length === 2
                    && ((productsType[BUSINESS_CONST.PRODUCT_CODE_TCR]
                        && productsType[BUSINESS_CONST.PRODUCT_CODE_CRP])
                        || !productsType[BUSINESS_CONST.PRODUCT_CODE_TCR])) {
                    return channelConstant.CODE_NAVIGATION.CODE_201;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
            },
            'receive-card': function () {
                if (_this.abreCuentasService.getOfficeStatus()) {
                    return channelConstant.CODE_NAVIGATION.CODE_200;
                }
                else {
                    return channelConstant.CODE_NAVIGATION.CODE_201;
                }
            },
        };
        var currentStepKey = this.getCurrentStep().key || 'default';
        return codeNext[currentStepKey]
            ? codeNext[currentStepKey]()
            : codeNext.default();
    };
    NavigationService.prototype.productLoanIsGranted = function () {
        var productsGranted = this.abreCuentasService.getPcoModel().granted_product_multi;
        var granteds = productsGranted.filter(function (i) { return i.product_type === 'loan'; });
        return granteds.length > 0;
    };
    NavigationService.prototype.flowloan = function (currentStep, flows) {
        var code;
        switch (currentStep.key) {
            case 'disbursement-offices-search':
                if (this.abreCuentasService.getPassScreenCity() !== channelConstant.navCode[1] || !this.productLoanIsGranted()) {
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                        code = channelConstant.navCode[201];
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[208] : channelConstant.navCode[204];
                    }
                }
                else {
                    code = channelConstant.navCode[207];
                }
                break;
            case 'city-offices-search':
                if (this.abreCuentasService.getPassScreenCity() !== channelConstant.navCode[1] || !this.productLoanIsGranted()) {
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                        code = channelConstant.navCode[201];
                    }
                    else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                        code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[208] : channelConstant.navCode[204];
                    }
                }
                else {
                    code = channelConstant.navCode[207];
                }
                break;
            case 'address-config-tc':
                if (flows.length === 3 && this.abreCuentasService.getOutlaySelection() !== BUSINESS_CONST.ITAU) {
                    code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[206] : channelConstant.navCode[205];
                }
                else if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU) {
                    if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; }) &&
                        this.abreCuentasService.getPostlogin() === true &&
                        this.abreCuentasService.getcreateProductSelected()) {
                        code = channelConstant.navCode[206];
                    }
                    else if (this.abreCuentasService.getcreateProductSelected()) {
                        code = channelConstant.navCode[201];
                    }
                    else {
                        code = channelConstant.navCode[204];
                    }
                }
                else if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.CHEQUE ||
                    this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.OTRO_BANCO) {
                    code = channelConstant.navCode[203];
                }
                break;
            case 'pay-day-form-tc':
                code = channelConstant.navCode[201];
                break;
            case 'outlay-other-bank':
                if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                    code = channelConstant.navCode[201];
                }
                else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                    code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[208] : channelConstant.navCode[204];
                }
                break;
            case 'opening-savings-account':
                if (flows.length === 3) {
                    if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU &&
                        flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                        code = channelConstant.navCode[200];
                    }
                    else {
                        code = channelConstant.navCode[203];
                    }
                }
                else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                    code = channelConstant.navCode[200];
                }
                else {
                    code = channelConstant.navCode[203];
                }
                break;
            case 'account-selection':
                if (flows.length === 3) {
                    if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.ITAU) {
                        code = channelConstant.navCode[201];
                    }
                    else if (this.abreCuentasService.getOutlaySelection() === BUSINESS_CONST.CHEQUE) {
                        code = channelConstant.navCode[200];
                    }
                }
                else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                    code = channelConstant.navCode[206];
                }
                else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                    code = channelConstant.navCode[201];
                }
                else {
                    code = channelConstant.navCode[200];
                }
                break;
            case 'receive-card':
                if (flows.length === 3) {
                    if (this.abreCuentasService.getOfficeStatus()) {
                        code = this.officeSelection();
                    }
                    else {
                        code = channelConstant.navCode[201];
                    }
                }
                else if (this.abreCuentasService.getOfficeStatus()) {
                    code = channelConstant.navCode[200];
                }
                else {
                    code = channelConstant.navCode[201];
                }
                break;
            case 'configuration-introduction':
                if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_TC; })) {
                    code = channelConstant.navCode[201];
                }
                else if (flows.find(function (find) { return find.flow == BUSINESS_CONST.PRODUCT_TYPE_REVOLVING; })) {
                    code = this.abreCuentasService.getClientProduct() ? channelConstant.navCode[206] : channelConstant.navCode[205];
                }
                break;
            default:
                code = channelConstant.navCode[200];
                break;
        }
        return code;
    };
    NavigationService.prototype.officeSelection = function () {
        if (this.abreCuentasService.getOutlaySelection() !== BUSINESS_CONST.ITAU) {
            return this.abreCuentasService.getClientProduct() ? channelConstant.navCode[205] : channelConstant.navCode[204];
        }
        else {
            return channelConstant.navCode[206];
        }
    };
    NavigationService.prototype.sendTagByCode = function (code, error) {
        switch (code) {
            case '132':
                this.pageLoadTag(error ? error.title : undefined, undefined, this.abreCuentasService.getPostlogin() ? 'pv468' : 'pv461');
                break;
            case '131':
                this.pageLoadTag(error ? error.title : undefined, undefined, this.abreCuentasService.getPostlogin() ? 'pv469' : 'pv462');
                break;
            case '141':
                this.pageLoadTag(undefined, undefined, 'pv466');
                break;
        }
    };
    NavigationService.prototype.routeApplicationFlow = function (route, applicationFlow) {
        var flowApp = {
            aprobados_en_firme: function (applicationFlow) { return applicationFlow.aprobados_en_firme; },
            aprobados_en_firme_multi: function (applicationFlow) { return applicationFlow.aprobados_en_firme_multi; },
            default: function (applicationFlow) { return applicationFlow.abrecuentas_flow_co; },
        };
        return flowApp[route] ? flowApp[route](applicationFlow) : flowApp.default(applicationFlow);
    };
    NavigationService.prototype.getPhase = function (item, phase) {
        return this.flowStructure[0].flows[item].phases[phase];
    };
    NavigationService.prototype.setCodeError = function (code) {
        this.codeError = code;
    };
    NavigationService.prototype.getCodeError = function () {
        return this.codeError;
    };
    return NavigationService;
}());
export { NavigationService };
